import React from "react";
import {PriceType} from "state/types";

export interface MedicationPriceElementProps {
    price: PriceType,
}

const MedicationPriceElementV3 = ({price}: MedicationPriceElementProps) => {
    const currencySymbol = price.currencySymbol;

    return (
        <pui-section flowDirection="horizontal" mainAxisArrangement="start" spacingbottom="mini">
            <pui-text class="currency-symbol" fontweight="normal" textsize="small" input={currencySymbol}/>
            <pui-text class="currency-amount" fontweight="normal" input={price.amount.toFixed(2)}/>
        </pui-section>
    )
}

export default MedicationPriceElementV3;
